import { render, staticRenderFns } from "./ConfigDetail.vue?vue&type=template&id=2c9026fe&scoped=true&"
import script from "./ConfigDetail.vue?vue&type=script&lang=js&"
export * from "./ConfigDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDetail.vue?vue&type=style&index=0&id=2c9026fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9026fe",
  null
  
)

export default component.exports